import { Palette } from '@mui/material/styles';
import { PaymentFormParams } from 'core/payments/entities';

type PaymentPalette = Palette['payment'];

const googleFontLink = 'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap';

// Style slots of the Solid card-form SDK (rendered in its own iframe), fed from the payment tokens.
const getFormStyles = (paymentPalette: PaymentPalette): PaymentFormParams['styles'] => ({
  submit_button: {
    'font-size': '14px',
    background: paymentPalette.submitButton,
    'border-radius': '30px',
    height: '49px',
    ':disabled': {
      'background-color': paymentPalette.submitButtonDisabled,
    },
  },
  input_group: {
    '.input-block': {
      flex: 'none',
    },
  },
});

export const getDefaultParams = (
  paymentPalette: PaymentPalette,
  params: PaymentFormParams = {},
): PaymentFormParams => ({
  ...params,
  formParams: {
    googleFontLink,
    isCardHolderVisible: true,
    ...params.formParams,
  },
  styles: getFormStyles(paymentPalette),
});

export const getLegalParams = (
  paymentPalette: PaymentPalette,
  params: PaymentFormParams = {},
): PaymentFormParams => ({
  ...params,
  formParams: {
    submitButtonText: 'Pay',
    googleFontLink,
    isCardHolderVisible: true,
    ...params.formParams,
  },
  styles: getFormStyles(paymentPalette),
});
